import React, { useEffect } from "react";
import Link from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import image from "../../images/icon-konek.png";
import share from "../../images/AppleShare.png";
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { format } from 'react-string-format';
import NotDisplayPWA from './NotDisplayPWA';
import CheckOS from './CheckOS';
import { withCookies, Cookies } from 'react-cookie';
import * as cookie from '../../scripts/CookiesAppGo';


const useStyles = makeStyles((theme) => ({
    close: {
        padding: theme.spacing(0.5),
    },
    imgLogo: {
        width: '50px',
        height: '50px',
        marginRight: '10px'
    },
    description: {
        marginTop: '10px'
    },
    linkInstall: {
        textAlign: 'center'
    },
    popInstallPWA: {
        bottom: '50px !important'
    }
}));


const InstallPWAIOS = (props) => {
    const [state, setState] = React.useState({
        open: true,
        vertical: 'bottom',
        horizontal: 'center',
    });

    const [neverDisplay, setNeverDisplay] = React.useState(false);
    const [showPWA, setShowPWA] = React.useState(false);

    const { vertical, horizontal, open } = state;

    const { cookies } = props;

    const { prompt } = CheckOS();

    const classes = useStyles();

    useEffect(() => {
        setNeverDisplay(cookies.get(cookie.pwa_never_display) === 'true');
    }, []);

    useEffect(() => {
        setShowPWA(!neverDisplay && prompt);
        setState({ ...state, open: !neverDisplay && prompt });
    }, [prompt, neverDisplay]);

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const handleOpenInstaller = () => {
        cookies.set(cookie.pwa_never_display, false, { path: '/' });
        setNeverDisplay(false);
        setState({ ...state, open: true });
    }

    if (prompt && !open) {
        return (
            <div className={classes.linkInstall}>
                <Link
                    component="button"
                    variant="body2"
                    onClick={handleOpenInstaller}
                    className={classes.link}
                >
                    {i18next.t("installPwa:install")} KoneK Mobile
                </Link>
            </div>
        )
    }

    return (
        <div>
            {showPWA && <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={handleClose}
                className={classes.popInstallPWA}
                message={
                    <React.Fragment>
                        <div style={{ maxWidth: "400px" }}>
                            <div style={{ float: 'left' }}>
                                <img
                                    src={image}
                                    className={classes.imgLogo}
                                />
                                {i18next.t('installPwa:install')} KoneK Mobile!
                                <div className={classes.description}>
                                    <span>{i18next.t('installPwa:description-ios')}</span>
                                    <div className={classes.description}>
                                        <span>
                                            {format(`${i18next.t('installPwa:description-ios2')}`,
                                                <img
                                                    src={share}
                                                    style={{ margin: "auto 4px 8px" }}
                                                    alt="Add to homescreen"
                                                    height="20"
                                                    width="20"
                                                />
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                }
                action={
                    <React.Fragment>
                        <NotDisplayPWA />
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            className={classes.close}
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </React.Fragment>
                }
                key={vertical + horizontal}
            />}
        </div>
    )
}

export default withNamespaces(['installPwa'], { wait: true })(withCookies(InstallPWAIOS));